import { ssn as ssnRe } from "./regexps";

/**
 * Extracts SeSSN from any text. If not available then it will return blank
 * @param text - Any text from which SSN needed to be extracted
 * @param isCV - True if extracting SSN from CV / resume
 */
export function extractSeSSN(text: string, isCV = false) {
  const re = () => {
    if (isCV) {
      return /\s(19|20)?(\d{6}([-+]|\s)\d{4})\s/g;
    } else {
      return /(19|20)?(\d{6}([-+\s])?\d{4})/g;
    }
  };
  return text?.match(re())?.[0].trim() || "";
}

export function parseSeSSN(v: string) {
  v = (v || "").trim();

  if (!v) {
    return null;
  }

  v = v.replace(/[^\d]/g, "");

  if (ssnRe.test(v)) {
    return v;
  }

  // yymmdd
  if (/^\d{6}$/.test(v)) {
    return withFirstTwoDigits(v);
  }

  // yymmddxxxx
  if (/^\d{10}$/.test(v)) {
    const dob = v.split("").slice(0, 6).join("");

    const num = v.split("").slice(6, 10).join("");

    return `${withFirstTwoDigits(dob)}-${num}`;
  }

  // yymmdd-xxxx
  if (/^([0-9]{6})+-[0-9]{4}$/.test(v)) {
    return withFirstTwoDigits(v);
  }

  // yyyymmddxxxx
  if (/\d{12}/.test(v)) {
    const dob = v.split("").slice(0, 8).join("");

    const num = v.split("").slice(8, 12).join("");

    return `${dob}-${num}`;
  }

  // if issue not resolved then return the initial value
  return null;
}

function withFirstTwoDigits(val: string) {
  const firstTo = getFirstTwoDigitsAsNumber(val);
  const addition = firstTo > 20 ? 19 : 20;
  return `${addition}${val}`;
}

function getFirstTwoDigitsAsNumber(val: string) {
  const v = `${val[0]}${val[1]}}`;
  return parseInt(v);
}
